import React, { useEffect, useRef } from "react";
import { Breadcrumb } from "antd";
import { useLocation } from "react-router-dom";

const DynamicBreadcrumb = () => {
    const { pathname } = useLocation();

    if (
        pathname === "/faqs" ||
        pathname === "/add-stars" ||
        pathname === "/add-client-and-role" ||
        pathname === "/clan-lite-growth-dashboard" ||
        pathname === "/role-master-configuration" ||
        pathname.startsWith("/edit-client-and-role") ||
        pathname.startsWith("/clan-management") ||
        pathname.toLowerCase() === "/productsconfiguration" ||
        pathname.toLowerCase() === "/products-configuration"
    ) {
        return null;
    }

    return (
        <Breadcrumb style={{ marginTop: '8%', marginLeft: '7%', marginBottom: "1%" }}></Breadcrumb>
    );
};
export default DynamicBreadcrumb;